// --------------------------------
// Copyright (c) 2023 Eco8 S.r.l.
// --------------------------------
import React from "react";
import { View, Text, TouchableOpacity, StyleSheet, Image } from "react-native";
import { FontAwesome, MaterialIcons } from "@expo/vector-icons";
import colors from "../../../config/colors";
import { useNavigation } from "@react-navigation/native";
import { selectTransferGroup } from "../../../axios/axiosConfig";
import fonts from "../../../config/fonts";

const RequestCard = ({ item, getTranslation, handleShowSnackbar }) => {
  const navigation = useNavigation();

  const handleAddButtonPress = async () => {
    let response;
    response = await selectTransferGroup(item.id);
    if (response.status === 200) {
      navigation.navigate(getTranslation("Tratte Trasporti"));
    } else {
      handleShowSnackbar(
        getTranslation(response.response.data),
        colors.red
      );
     
    }
  };

  const handlePhoneCall = () => {
    if (item.phone) {
      window.open(`tel:${item.phone}`);
    }
  };

  return (
    <TouchableOpacity
      onPress={handleAddButtonPress}
      style={styles.itemContainer}
    >
      {item.isUrgent && (
        <View style={styles.urgentLabel}>
          <Text style={styles.urgentText}>{getTranslation("URGENTE")}</Text>
        </View>
      )}
      {item.isPreviouslyOwned && (
        <View style={styles.previouslyOwnedLabel}>
          <Image
            source={require("../../../images/Transportatore/delivery.png")}
            style={styles.previouslyOwnedImage}
          />
        </View>
      )}
      {item.toCall && (
        <TouchableOpacity style={styles.phoneButton} onPress={handlePhoneCall}>
          <FontAwesome name="phone" size={20} color={colors.green} />
        </TouchableOpacity>
      )}
      <View style={styles.leftContent}>
        <Text style={styles.category}>
          {item.type === "Customer"
            ? getTranslation("C")
            : item.type === "Manual"
            ? getTranslation("M")
            : getTranslation("A")}
        </Text>
      </View>
      <View style={styles.infoContainer}>
        {item.isBlocked && (
          <MaterialIcons
            name="error"
            size={20}
            color={colors.red}
            style={styles.urgentIcon}
          />
        )}
        <Text style={styles.description}>{item.depositName}</Text>
        <View style={styles.tripsLabel}>
          <Text style={styles.tripsText}>{item.transferNumber}</Text>
        </View>
      </View>
    </TouchableOpacity>
  );
};

const styles = StyleSheet.create({
  itemContainer: {
    flexDirection: "row",
    alignItems: "center",
    padding: 10,
    marginVertical: 4,
    borderRadius: 20,
    borderWidth: 1,
    backgroundColor: colors.white,
    position: "relative",
    width: "100%",
  },
  urgentLabel: {
    position: "absolute",
    top: 0,
    left: 5,
    backgroundColor: "red",
    paddingHorizontal: 6,
    paddingVertical: 2,
    borderRadius: 12,
    zIndex: 1,
  },
  urgentText: {
    color: "white",
    fontWeight: "bold",
    fontFamily: fonts.regular,
  },
  previouslyOwnedLabel: {
    position: "absolute",
    top: -10,
    right: 45,
    zIndex: 1,
  },
  previouslyOwnedImage: {
    width: 30,
    height: 30,
    borderRadius: 15,
  },
  phoneButton: {
    padding: 10,
    position: "absolute",
    left: 10,
    top: 20,
    transform: [{ translateY: -10 }],
    zIndex: 2,
  },
  emergencyIcon: {
    position: "absolute",
    top: 10,
    left: 30,
    zIndex: 1,
  },
  leftContent: {
    alignItems: "center",
    position: "absolute",
    top: 20,
    left: 40,
    zIndex: 1,
  },
  category: {
    fontSize: 16,
    fontFamily: fonts.regular,
    color: "gray",
  },
  infoContainer: {
    flex: 1,
    flexDirection: "row",
    alignItems: "center",
    marginLeft: 90,
    justifyContent: "space-between",
  },
  urgentIcon: {
    marginRight: 10,
  },
  description: {
    fontSize: 18,
    fontWeight: "bold",
    fontFamily: fonts.regular,
    flex: 1,
  },
  tripsLabel: {
    width: 30,
    height: 30,
    backgroundColor: colors.green,
    borderRadius: 15,
    justifyContent: "center",
    alignItems: "center",
  },
  tripsText: {
    color: "white",
    fontWeight: "bold",
    fontFamily: fonts.regular,
  },
});

export default RequestCard;
